import type { Component } from "vue";

export const routes = [
  {
    path: "/merchantCredit/manage",
    name: "merchant-credit-manager",
    component: (): Promise<Component> => import("./views/MerchantCreditManager.vue"),
    meta: {
      requiresAuth: true,
      requiredRoles: [],
      requiredGroups: [],
    },
  },
];
